/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Web_PagesInputs */

const en_common_web_pages = /** @type {(inputs: Common_Web_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web pages`)
};

const es_common_web_pages = /** @type {(inputs: Common_Web_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas web`)
};

/**
* | output |
* | --- |
* | "Web pages" |
*
* @param {Common_Web_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_web_pages = /** @type {((inputs?: Common_Web_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Web_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_web_pages(inputs)
	return en_common_web_pages(inputs)
});